import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import * as SplashScreen from 'expo-splash-screen';
import { clientLogger, reportRumError } from '@/lib/datadog';

export class BootErrorBoundary extends React.Component<
  { children: React.ReactNode; diagnosticsEnabled: boolean },
  { error: Error | null }
> {
  override state = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    clientLogger.error('[BootErrorBoundary] Caught error', { error });
    reportRumError(error, { componentStack: info.componentStack });
    SplashScreen.hideAsync().catch(() => {});
  }

  override render() {
    const { error } = this.state;

    if (!error) {
      return this.props.children;
    }

    return (
      <View style={styles.errorFallback}>
        <Text style={styles.errorTitle}>Something went wrong.</Text>
        {this.props.diagnosticsEnabled ? (
          <Text style={styles.errorDetails}>{String(error)}</Text>
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create(theme => ({
  errorDetails: {
    color: theme.colors.pressMuted,
    fontFamily: theme.typography.fontFamily.body,
    fontSize: 14,
    textAlign: 'center',
  },
  errorFallback: {
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 24,
  },
  errorTitle: {
    color: theme.colors.press,
    fontFamily: theme.typography.fontFamily.display,
    fontSize: 18,
    fontWeight: '900',
    marginBottom: 8,
    textTransform: 'uppercase',
  },
}));
